import { InteractHasNotificationActiveIcon, InteractNotificationActiveIcon } from '@/client/assets';
import { AuthedButton } from '@/client/components/authed-button';
import { useNotificationStatus } from '@/client/hooks/use-notification-status';
import { useSignedUserInfo } from '@/client/hooks/use-signed-user-info';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useMemo } from 'react';
import useMedia from 'react-use/lib/useMedia';
import { useLocation, useRoute } from 'wouter';

export const NavNotification = () => {
  const [, navigate] = useLocation();
  const { hasNewNotification } = useNotificationStatus(api);
  const { data: singer } = useSignedUserInfo(api);
  const link = useMemo(() => `/user/${singer?.uid}/notification`, [singer?.uid]);
  const [isActive] = useRoute('/user/:uid/notification');
  const isDesktop = useMedia('(min-width: 768px)');
  if (!isDesktop) return null;
  return (
    <AuthedButton
      showAuth={false}
      showLoading={false}
      onClick={() => navigate(link)}
      aria-label="Notifications"
      variant="outline"
      size="icon"
      className={cn(
        'p-2 border border-foreground/4 shadow-none',
        isActive ? 'bg-foreground/5' : 'bg-transparent hover:bg-foreground/5'
      )}
    >
      {!hasNewNotification && <InteractNotificationActiveIcon className="size-5 fill-foreground" />}
      {hasNewNotification && <InteractHasNotificationActiveIcon className="size-5 fill-foreground" />}
    </AuthedButton>
  );
};
